var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.block.type)?_c('Banner',{attrs:{"block":_vm.block}}):_c('Slider',{attrs:{"block":_vm.block}})
}
var staticRenderFns = []

export { render, staticRenderFns }